// Takes "John Michael Dlamini" → returns "J. Dlamini"
function getDisplayName(fullName: string | null): string {
  if (!fullName) return "Guest";

  const parts = fullName.trim().split(" ");

  if (parts.length === 1) return parts[0]; // only one name

  const initial = parts[0].charAt(0).toUpperCase();
  const lastName = parts[parts.length - 1]; // always grab last word

  return `${initial}. ${lastName}`;
}

export default getDisplayName;